"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
var makeStyles_1 = require("../../../theme/makeStyles");
exports.default = (0, makeStyles_1.makeStyles)(function (theme) { return ({
    root: {
        display: 'flex',
        flexDirection: 'column',
        alignContent: 'center',
        background: theme.colors.white,
        transition: 'all 0.2s ease-in-out'
    },
    disabled: {
        cursor: 'not-allowed',
        '& *': {
            color: theme.colors.gray300
        },
        '& input': {
            background: 0
        }
    },
    labelWrapper: {
        display: 'flex',
        alignItems: 'center',
        paddingBottom: '4px'
    },
    option: {
        color: theme.colors.gray500
    },
    help: {
        alignSelf: 'flex-start'
    },
    helpError: {
        marginLeft: '4px'
    },
    helpContainer: {
        display: 'flex',
        alignItems: 'center',
        justifyContent: 'start',
        paddingTop: '4px',
        '& svg': {
            '&:first-child': {
                alignSelf: 'flex-start',
                marginTop: '2px',
                flexShrink: '0'
            }
        }
    },
    select: {
        width: '100%',
        padding: ['9px', '32px', '9px', '12px'],
        minHeight: '48px',
        backgroundColor: theme.colors.white,
        color: theme.colors.gray500,
        fontFamily: theme.typography.fontFamily.sansSerif,
        fontWeight: theme.typography.fontWeight.medium,
        fontSize: '16px',
        lineHeight: '28px',
        textOverflow: 'ellipsis',
        border: "1px solid ".concat(theme.colors.gray300),
        borderRadius: '4px',
        outline: 'none',
        '&:disabled': {
            cursor: 'not-allowed',
            color: theme.colors.gray300,
            pointerEvents: 'none'
        },
        '& option': {
            '&:first-child': {
                display: 'none'
            }
        },
        appearance: 'none',
        '&:focus-within': {
            outline: "2px solid ".concat(theme.colors.gray500),
            outlineOffset: '-1px'
        }
    },
    selectContainer: {
        display: 'flex',
        alignItems: 'center',
        position: 'relative'
    },
    selectIcon: {
        position: 'absolute',
        top: '16px',
        right: '8px',
        pointerEvents: 'none'
    },
    error: {
        borderColor: theme.colors.warningAccessible,
        outline: "2px solid ".concat(theme.colors.warningAccessible),
        outlineOffset: '-1px'
    }
}); });
